import { SchemaCallIntelligenceV2Service } from './service';
import { QueryEndpointName } from './types';

export const STANDARD_QUERY_ENDPOINT_NAMES = [
  'GetDemoPersons',
  'GetCallsOverview',
  'OverviewStats',
  'GetCallFollowupsStats',
  'GetSchedulingAggregateStats',
  'GetServiceQualityStats',
  'GetCallsViewByLocation',
  'ListAITaskSettings',
  'GetCallMetadataNew',
  'GetTrialBackfillStatus',
] as const satisfies (keyof typeof SchemaCallIntelligenceV2Service)[];
export const INFINITE_QUERY_ENDPOINT_NAMES = ['ListFollowups', 'ListCalls'] as const satisfies (keyof Omit<
  typeof SchemaCallIntelligenceV2Service,
  (typeof STANDARD_QUERY_ENDPOINT_NAMES)[number]
>)[];
export const QUERY_ENDPOINT_NAMES = [...STANDARD_QUERY_ENDPOINT_NAMES, ...INFINITE_QUERY_ENDPOINT_NAMES] as const;

export const MUTATION_ENDPOINT_NAMES = [
  'UpdateAITaskSettings',
  'BulkUpdateAITaskSettings',
] as const satisfies (keyof Omit<typeof SchemaCallIntelligenceV2Service, QueryEndpointName>)[];

/**
 * A field that can be added to list call infinite query pages to allow extra records to be allowed in the page response
 */
export const CALL_LIST_PAGE_OVERFLOW_ALLOWED_FIELD = '__pageOverflowAllowed' as const;
